/** @format */
import {differenceInMinutes, endOfDay} from 'date-fns';

const getMinutesLeft = (endDate: Date): number => {
  const expiresDate = endOfDay(endDate);
  return differenceInMinutes(expiresDate, new Date());
};

export {getMinutesLeft};
